export const TickerTape = {
  mounted() {
    // duplicate the content nodes inside the ticker tape 4 times so that the ticker tape
    // can appear to scroll continuously
    const childDiv = this.el.children[0];
    const contentDivs = childDiv.children;
    let originalContentWidth = 0;

    for (let i = 0; i < contentDivs.length; i++) {
      originalContentWidth += contentDivs[i].offsetWidth;
    }

    const childCount = contentDivs.length;

    // create 3 more copies of the content so translateX(-25%) will work
    for (let i = 0; i < 3; i++) {
      for (let j = 0; j < childCount; j++) {
        const el = contentDivs[j].cloneNode(true);
        childDiv.appendChild(el);
      }
    }

    // Set the width of the ticker tape to be 4 times the width of the original content
    childDiv.style.width = originalContentWidth * 4 + 'px';
  }
};
